import { createTheme, responsiveFontSizes } from '@material-ui/core/styles';

import { baseTheme, lightTheme } from 'themeTokens';

const theme = createTheme(baseTheme, lightTheme);

export default responsiveFontSizes(theme);
